<template>


    <section  class="navbarsection" style="margin-top: -50px;">
          <div class="txtdata">
            <h1  style="padding-top: 200px;"></h1>
          </div>
            <div class="videosection" >
              <div  v-show="pvisvideo === true && pvpictureimage === false ">
                <Transition class="transition thing">
                  <video-background 
                    playbackRate=0.98
                    :src="src"
                    :poster="poster"
                    :class="`thing playercss`"
                    :style="`height: 600px;`">
                  </video-background>
                </Transition>
              </div>
            
                <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
                </div>
      
                <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
                v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
       
          </div>
          <div class="overlay"></div>
          <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
            <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
          </div>
        </section>

  <section>
    <div style="margin-top: -300px;">
      <OpsProd :opsproducts="opsproducts" />
    </div>
  </section>

  <section class="opsprod">
    <div class="container" style="width: 100%; text-align: left;">
      <div class="row">
        <div class="col-xm-12 col-sm-12 col-md-6">
          <div v-html="oppgproddesc" class="prodinfodesc" ></div>
        </div>
        <div class="col-xm-12 col-sm-12 col-md-6">
          <PiclistCards :productlistcards="opsproductscards" />
        </div>
      </div>
    </div>
  </section>
<!--   
  <section class="graphcont">
    <div class="container">
      
      <div class="flex-container">
        <div class="silverchartmaintxt"><b>{{opgraphtoptitle}}</b></div>
        <div class="flex-item chart1">
          <div v-html="opsleftgraphtitle" class="maintxt"></div>
          <canvas id="myChart"></canvas>
        </div>

        <div class="flex-item charttext1 formatbottom">
            <p class=""><small class="chartgeneral" v-html="opleftsupplytext"></small></p>
        </div>

        <div class="flex-item chart1 chart2">
          <div v-html="opsrightgraphtitle" class="maintxt maintxt1"></div>
          <canvas id="myChart1" class=""></canvas>
        </div>

        <div class="flex-item charttext2 formatbottom1 ">
            <p class=""><small class="chartgeneral" v-html="oprightsupplytext"></small></p>
        </div>
      </div>
    </div>
  </section> -->

  <section class="threecards">
    <div>
      <ThreecardsSection :allcardsdata="contdata" />
    </div>


    <div class="container bottomtextdiv">
      <p v-html="opovbottomtext"></p>
    </div>
  </section>

 


</template>

<script>

import OpsProd from '@/components/OpsProd.vue';
import PiclistCards from '@/components/PiclistCards.vue';
import ThreecardsSection from '@/components/ThreecardsSection.vue';
import Chart from 'chart.js/auto';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
import axios from 'axios';
require('@/globalDeclare');


export default {
  name: 'AboutView',
  components: {
 OpsProd, PiclistCards, Chart, ThreecardsSection
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  pvwebm: '',
  pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,
  picurl: myUrlPath,

  cvdesc: '',
  valuesphotos: [],
  valuesphotosabout: [],
  cvpurposevaluelinkname: '',
  cvlink: '',
  pictureimage: '',

  //General inputs
  oppgdesc: '',
  oppgproddesc: '',
  opgraphtoptitle: '',
  opsleftgraphtitle: '',
  opleftsupplytext: '',
  opsrightgraphtitle: '',
  oprightsupplytext: '',
  opprodinfo: '',
  investtext: '',
  investimg: '',
  investlinktext: '',
  investlink: '',
  prodtext: '',
  prodimg: '',
  prodlinktext: '',
  prodlink: '',
  lcarbontext: '',
  lcarbonimg: '',
  lcarbonlinktext: '',
  lcarbonlink: '',
  opovbottomtext: '',
  strbuild: '',

  //ops products declarations
  opsproducts: [],
  opsproductscards: [],
  opssilverdemandgraphlabels: [],
  opssilverdemandgraphdata: [],
  opssilversupplygraphlabels: [],
  opssilversupplygraphdata: [],

  contdata: [],

  showImage: false,
  publicPath: window.location.origin,

  myPicUrl: '',

  cvvisibility: true,

  height: 0,
  width: 0,
 
  }
},
methods: {
  logChange(event) {
    this.showImage = true
    this.histsearchid = event
  //------------Homepage Stock Prices---------------
  axios.get(`gethistorydataid/${this.histsearchid}`).then(
      response => {
          this.yearimages = response.data
    })
    .catch((error) => {
        console.log(error)
      })
},
resizeHandler() {
      this.height = window.innerHeight;
      this.width = window.innerWidth;
  }
},

created() {
    window.addEventListener("resize", this.resizeHandler);
},

destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
},

mounted() {
  let showImage = Boolean
  showImage = false
  this.myPicUrl = myUrlPath

  this.height = window.innerHeight;
  this.width = window.innerWidth;

 axios.get('allpagespv/products').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.picurl + this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.picurl + this.videoimage.pvposter
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.picurl + this.videoimage.pvpanorama1
      this.pvpanorama2 = this.picurl + this.videoimage.pvpanorama2
      this.pvpanorama3 = this.picurl + this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      this.pvpictureimage = this.videoimage.pvpictureimage

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
  })
  .catch((error) => {
        console.log(error)
      })
  
  
  //------------Operations General product page info ---------------
  axios.get('getopsproductgeneral/').then(
    response => {
    this.oppgdesc = response.data.oppgdesc
    this.oppgproddesc = response.data.oppgproddesc
    this.opgraphtoptitle = response.data.opsproductspgraphtoptitle
    this.opsleftgraphtitle = response.data.opsleftgraphtitle
    this.opleftsupplytext = response.data.opleftsupplytext
    this.opsrightgraphtitle = response.data.opsrightgraphtitle
    this.oprightsupplytext = response.data.oprightsupplytext
    this.opprodinfo = response.data.opprodinfo
    this.investtext = response.data.investtext
    this.investimg = this.myPicUrl + response.data.investimg
    this.investlinktext = response.data.investlinktext
    this.investlink = response.data.investlink
    this.prodtext = response.data.prodtext
    this.prodimg = response.data.prodimg
    this.prodlinktext = response.data.prodlinktext
    this.prodlink = response.data.prodlink
    this.lcarbontext = response.data.lcarbontext
    this.lcarbonimg = response.data.lcarbonimg
    this.lcarbonlinktext = response.data.lcarbonlinktext
    this.lcarbonlink = response.data.lcarbonlink
    this.opovbottomtext = response.data.opovbottomtext
  })
  .catch((error) => {
      console.log(error)
    })   

  //------------Operations products page products ---------------
  axios.get('getopspageproducts/').then(
    response => {
    this.opsproducts = response.data
  })
  .catch((error) => {
      console.log(error)
    })   

  //------------Operations products page Cards ---------------
   axios.get('valuesphotos1/products').then(
    response => { 
    this.opsproductscards = response.data
  })
  .catch((error) => {
      console.log(error)
    }) 

  //------------Container Section---------------
  axios.get('getallcardsectionsdata/products').then(
    response => {
        this.contdata = response.data
    })
  .catch((error) => {
      console.log(error)
    })

  //------------Operations products page Cards ---------------
   axios.get('getsilverdemandgraphdata/products').then(
    response => { 
      this.opssilverdemandgraphlabels = response.data.glabels
      this.opssilverdemandgraphdata = response.data.gdata
    const ctx = document.getElementById('myChart');
    const myChart = new Chart(ctx, {
    type: 'doughnut',
    data: {
        labels: this.opssilverdemandgraphlabels,
        datasets: [{
            label: '# of Votes',
            data: this.opssilverdemandgraphdata,
            backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)'
            // 'rgba(153, 102, 255, 0.2)',
            // 'rgba(255, 159, 64, 0.2)'
        ],
        borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)'
            // 'rgba(153, 102, 255, 1)',
            // 'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1,
            hoverOffset: 24,
            responsive: true,
            maintainAspectRatio: true,
            resizeDelay:  0
        }]
    },
    options: {
      animation:{
        animateRotate: true
      },
      responsive: true,
      // layout: {
      //       padding: 30
      //   },
      plugins: {
        legend: {
          display: true,
            position: "bottom",
            align: "center"
          }
        }
    }
    });
    myChart;
  })
  .catch((error) => {
      console.log(error)
    })   

  //------------Operations products page Cards ---------------
   axios.get('getsilversupplygraphdata/products').then(
    response => { 
    this.opssilversupplygraphlabels = response.data.rlabels
    this.opssilversupplygraphdata = response.data.rdata

    const ctx = document.getElementById('myChart1');
    const myChart1 = new Chart(ctx, {
    type: 'doughnut',
    data: {
        labels: this.opssilversupplygraphlabels,
        datasets: [{
            label: '# of Votes',
            data: this.opssilversupplygraphdata,
            backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)'
            // 'rgba(153, 102, 255, 0.2)',
            // 'rgba(255, 159, 64, 0.2)'
        ],
        borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)'
            // 'rgba(153, 102, 255, 1)',
            // 'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1,
            hoverOffset: 24,
            responsive: true,
            // maintainAspectRatio: true,
            resizeDelay: 0
            // radius: 100,
            
        }]
    },
    options: {
      animation:{
        animateRotate: true
      },
      // layout: {
      //       padding: 30
      //   },
      responsive: true,
      // aspectRatio: 1.4,
      plugins: {
        legend: {
          display: true,
            position: "bottom",
            align: "center"
          }
        }
    }
    });
    myChart1;
 
  })
  .catch((error) => {
      console.log(error)
    }) 
},

}

</script>

<style scoped>
.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}


 .chartcss {
  width: 100%;
 }


 .chartsection {
  background-color: whitesmoke;
  
 }


.bottomtextdiv {
  height: 200px;
  margin-top: 100px;
  margin-bottom: 100px;
}
.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
/* Move the background and make it larger. 
/* Media Query CSS*/

 /*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
 .threecards{
  margin-top: 2600px;
 }
  
 }


 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .threecards{
    margin-top: 2500px;
   }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {

  .threecards{
    margin-top: 1300px;
   }


 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .threecards{
    margin-top: 800px;
   }
   .opsprod {
    margin-top: -200px;
   }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
 
  .threecards{
    margin-top: 800px;
   }
 

 } 

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1400px) {
    .threecards{
      margin-top: 500px;
     }
  }
</style>
